const Data = [
    {
        name: "J.Rameshwar Naik",
        position: "Head, Awareness Projects",
        imageUrl: "/assets/images/members/J.RameshwarNaik.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Priyam Goenka",
        position: "PRAYAS Coordinator",
        imageUrl: "/assets/images/members/PriyamGoenka.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Revansh Phirani",
        position: "PRAYAS Coordinator",
        imageUrl: "/assets/images/members/RevanshPhirani.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    
]

export default Data;